import React from "react";

const yashwant_bhosale = () => {
  return (
    <div>
      <h1>Yashwant Bhosale</h1>
      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>
      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The initial shortlisting was based on CGPA and later they conducted 3
        tests:
      </p>
      <ol>
        <li>
          Aptitude test (consisted general aptitude questions and 1 easy coding
          question){" "}
        </li>
        <li>UBS Culture Match Assessment </li>
        <li>Junior Talent Cognitive Assessment</li>
      </ol>
      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The interview process followed a straightforward timeline. Initially,
        candidates were shortlisted for the aptitude round, primarily based on
        their CGPA. We were then asked to register on the UBS recruitment
        platform using our college email IDs.
      </p>
      <p>
        After the assessments,{" "}
        <strong>
          nine students were shortlisted for the final interview round
        </strong>
        . Note: <strong>UBS had conducted a hackathon in March 2025</strong>,
        and participants who were shortlisted for that event were{" "}
        <strong>directly advanced to the final interview round</strong>.
      </p>
      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round had three sections.
      </p>
      <ul>
        <li>
          <strong>MCQ Section (15 questions):</strong> Mostly computer science
          related, with questions focused on concepts like OOP and DSA.{" "}
        </li>
        <li>
          <strong>Aptitude Section (15 questions):</strong> Included general
          aptitude questions mostly puzzles and basic math problems.{" "}
        </li>
        <li>
          <strong>Coding Section (1 question):</strong> There was one easy
          coding question. Everyone got a different one, but overall the
          difficulty level was pretty manageable.
        </li>
      </ul>
      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        <strong>Nine students</strong> were shortlisted after the aptitude
        round. Out of those, <strong>three</strong> were directly shortlisted
        through the hackathon that UBS conducted in March 2025.
      </p>
      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced on <strong>4th August 2025</strong> at
        around 7:15 PM, and the interviews were scheduled the next morning on{" "}
        <strong>5th August</strong> from 9 AM onwards. So, I realistically had
        very little time to prepare.
      </p>
      <p>
        During that short period, I focused on getting my thoughts together
        about the key concepts and made sure I knew every small detail about the
        projects mentioned in my resume. One thing I’d really recommend is
        preparing a short and clear description of your projects or any work
        you’ve done, so that even a layman can understand it.
      </p>
      <p>
        I was already confident about my projects since they involved hands-on
        work, but I realized that summarizing them clearly can be challenging,
        especially when the project topic is niche, like in many DSA-related
        projects. My approach was to start with the problem statement, describe
        the actual problem rather than just the idea, and then move on to the
        solution and the unique aspect or impact of the project.
      </p>
      <p>
        During this time, I also went through some behavioral and “about
        yourself” questions, since those can catch you off guard if you’re not
        prepared. Lastly, I made sure to read about the company, its vision, and
        overall culture before the interview.
      </p>
      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>
      <p>There were two main rounds in the selection process:</p>
      <ol>
        <li>
          <strong>Aptitude Round</strong>{" "}
        </li>
        <li>
          <strong>Interview Round</strong>
        </li>
      </ol>
      <p>
        The <strong>Aptitude Round</strong> was straightforward. The aptitude
        questions were mostly general and not too difficult, while the MCQs
        ranged from easy to medium level. The coding question was different for
        each candidate, but overall, it was fairly simple for most people. After
        this round, <strong>nine students were shortlisted</strong> for the
        interviews.
      </p>
      <p>
        The <strong>Interview Round</strong> was roughly divided into two parts
        - <strong>Technical + HR</strong> and <strong>Pure HR</strong>.
      </p>
      <p>
        The <strong>first part (Technical + HR)</strong> lasted around 30-35
        minutes in my case. The technical portion mainly focused on projects and
        internship work, especially the DSA project. A significant portion of
        the interview involved behavioral questions based on ethical dilemmas.
      </p>
      <p>For example:</p>
      <ul>
        <li>
          <p>
            <em>
              “If I am working on something and some colleague of mine has
              already written the code for the same feature, would I ‘take’
              their code?”
            </em>{" "}
            The expectation here was to recognize the principle of{" "}
            <strong>code reusability</strong>, instead of duplicating effort, it
            is more efficient to use and build upon existing reliable code while
            giving proper credit.
          </p>
        </li>
        <li>
          <p>
            <em>
              “If I get an offer from Microsoft tomorrow, would I leave the
              company?”
            </em>{" "}
            This question tested decision-making and professional priorities.
          </p>
        </li>
      </ul>
      <p>
        A simple DSA question was also asked during this round
        <br />
        The <strong>second part (Pure HR)</strong> was more informal and focused
        on personal aspects like family background, hobbies, and interests.
      </p>
      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        During the Technical + HR round, the interviewers mostly focused on{" "}
        <strong>behavioral questions</strong>. Apart from that, the discussion
        centered on the{" "}
        <strong>
          topics, skills, projects, and internships mentioned in my resume
        </strong>
        .{" "}
      </p>
      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Honestly, my internship preparation wasn’t very structured, but I’d
        definitely recommend planning and organizing your preparation.
        <br />
        For coding practice, I solved LeetCode questions, although I didn’t
        follow a strict roadmap. For those looking for a structured approach,
        the{" "}
        <a href="https://neetcode.io/roadmap">
          <strong>NeetCode Roadmap</strong>
        </a>{" "}
        is a great resource. I’d recommend using it as a reference and making
        sure to solve <strong>additional questions on the topics listed</strong>{" "}
        to gain more practice.
        <br />
        For aptitude questions, I mostly used <strong>IndiaBIX</strong>, and for
        puzzles, <strong>GeeksforGeeks (GFG)</strong> was helpful.
        <br />
        For core CS concepts and related interview questions, I referred to{" "}
        <strong>GeeksforGeeks</strong> and <strong>InterviewBit</strong>.
      </p>
      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        For coding questions, the hardest part is often{" "}
        <strong>recognizing the underlying problem</strong> in a given problem
        statement and structuring it properly. Once the problem is correctly
        identified, you can decide which{" "}
        <strong>data structure or algorithm</strong> to use. If the problem is
        misidentified (something I’ve done many times), a lot of time can be
        wasted chasing the wrong approach.
        <br />
        The key is to <strong>solve a lot of problems consciously</strong>,
        think about different solutions, and explore multiple approaches.
        There’s no shortcut, building intuition takes practice.
        <br />
        One tip I’d highly recommend is to{" "}
        <strong>document your solutions</strong> in a structured way, maybe in a
        GitHub repository. Include the problem statement, your solution, the
        optimal solution, your approach, and the time and space complexity. This
        way, when you revisit problems later, you’re not starting from scratch
        and can track your improvement over time.
      </p>
      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?
      </p>
      <p>
        I was asked quite a few questions about my <strong>projects</strong>.
        Many candidates were also asked about their{" "}
        <strong>social internship work</strong>, and in my case,{" "}
        <strong>
          my work was about setting up a payment gateway for an NGO
        </strong>
        , which was discussed for a significant amount of time.
        <br />
        However, I wasn’t asked many questions about the{" "}
        <strong>clubs or extracurricular activities</strong> listed on my
        resume.
      </p>
      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?
      </p>
      <p>
        One thing I would definitely recommend is knowing about the company and
        its principles. The HR round often includes questions about your
        understanding of the company, and being well-prepared for these
        questions is always a safe approach.
      </p>
      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The internship process can be stressful. But make sure you are taking it
        seriously, you’ll end up learning a lot of things. Not just related to
        computer science but other things like patience, handling rejections.
        <br />
        Trust your skills, your passion, your efforts especially during
        interview rounds. You’ll do good.
        <br />
        All the best!
      </p>
      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 7276443096
        <br />
        <strong>Email :</strong> <a href="mailto:yashwantbhosale07@gmail.com">yashwantbhosale07@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/yashwant-bhosale-4ab062292/">
          Yashwant Bhosale
        </a>
      </p>

      <hr />
    </div>
  );
};

export default yashwant_bhosale;
